<template>
  <div>
    <h2 class="step-name"> Dry Cow and Teatseal Order </h2>
    <span class="glyphicon glyphicon-envelope" aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Email might be generated"></span>
    <h3> NB: As returns on DCAT products are not accepted, please ensure the
      quantities ordered are accurate </h3>

    <div class="step-section">
      <div class="clearfix" :style="{ width: 400 + widthForRow(getFieldValue('FARMS')) + 'px' }">

        <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
          <h3>{{ farm.farm_label }}</h3>

          <div class="form-group">
            <label for="herd_size">Herd size</label>
            <input type="text"
                   :value="getFieldValue(`farm_${farm.id}-herd_size`)"
                   class="form-control"
                   :id="`farm_${farm.id}-herd_size`"
                   disabled>
          </div>
          <radio-input label="Milking Herd Dry Cow therapy and Teatsealant"
                       :field-name="`farm_${farm.id}-order_distribution`"
                       :choices="[
                                 {value: 'Delivered', display: 'Delivered (please add delivery instructions below)'},
                                 {value: 'Winton - Pick Up', display: 'Winton - Pick Up'},
                                 {value: 'Gore - Pick Up', display: 'Gore - Pick Up'},
                                 {value: 'Tapanui - Pick Up', display: 'Tapanui - Pick Up'},
                                 ]"
                       :disabled="isReadOnly">
          </radio-input>
                                 <!-- {value: 'Invercargill - Pick Up', display: 'Invercargill - Pick Up'}, -->

          <date-input label="Required by date"
                      :field-name="`farm_${farm.id}-date_required`"
                      :disabled="isReadOnly">
          </date-input>

          <text-input label="Contact Name"
                      :field-name="`farm_${farm.id}-contact_name`"
                      :disabled="isReadOnly">
          </text-input>

          <text-input label="Contact Number"
                      :field-name="`farm_${farm.id}-contact_phone`"
                      :disabled="isReadOnly">
          </text-input>


          <drug-allocation :animal-name="farm.farm_label"
                      :drugs="getFieldValue('DCAT_DRUGS')"
                      :allocations="getFieldValue(`farm_${farm.id}-allocations`)"
                      @new-allocations='updateAllocations(`farm_${farm.id}-allocations`, $event)'
                      :drugs-used-last-year="getFieldValue('DRUGS_USED_LAST_YEAR').FARMS[farm.id] || {}"
                      :is-read-only="isReadOnly">
          </drug-allocation>
        </div>
      </div>
    </div>

    <hr>

    <div class="step-section">
      <dl class="row">
        <dt class="col-md-3 col-md-offset-3"> Heifer Teatsealant </dt>
        <dd class="col-md-3"><u>Always delivered by Vet tech</u></dd>
      </dl>

      <div v-for="(nhdco_data, nhdco_id) in getFieldValue('NON_HERD_DCO')" :key="'nhdco-'+nhdco_id" class="row">

				<template v-if="getFieldValue('NON_HERD_DCO')[nhdco_id].delete != true">
					<non-herd-animal-order :model="nhdco_data"
						:hdco-id="nhdco_id"
						:is-new="false"
						:dcat-drugs="getFieldValue('DCAT_DRUGS_HEIFERS')"
						:drugs-used-last-year="getFieldValue('DRUGS_USED_LAST_YEAR').ANIMALS"
						>
					</non-herd-animal-order>
				</template>
      </div>
    </div>

    <div class="step-section">
      <div v-for="(newForm, index) in newNonHerdDcos" :key="'newForm-'+index" class="row">
        <non-herd-animal-order :model="newForm"
                               :dcat-drugs="getFieldValue('DCAT_DRUGS_HEIFERS')"
                               :hdco-id="index"
                               :is-new="true"
                               :drugs-used-last-year="getFieldValue('DRUGS_USED_LAST_YEAR').ANIMALS"
                               >
        </non-herd-animal-order>
      </div>
    </div>
	
		<modal v-if="showSelectHeiferAnimalForm">
      <div slot="header">
        <h3>Select Heifer Animal</h3>
      </div>
      <div slot="body">
				<model-select v-model="heifer" :options="freeOtherAnimalsOptions" >
        </model-select>
      </div>
			<div slot="footer">
				<button class="modal-default-button btn btn-success" @click="addNewOtherAnimalForm(heifer); showSelectHeiferAnimalForm = false">
					Create
				</button>
				<button class="modal-default-button btn btn-default" @click="heifer = {} ; showSelectHeiferAnimalForm = false">
					Cancel
				</button>
			</div>
    </modal>

		<button class="btn btn-primary" v-if="canAddOtherAnimal" @click="prepopulateHeifer() ;showSelectHeiferAnimalForm = true; ">
			Add other animal
		</button>

    <hr>

    <div class="step-section">
      <div>
        <p>
        To receive Early Bird prices, dry cow and teat sealant must be
        <strong>ordered prior to 30th April, and paid for by 20th May</strong> after
        which standard retail pricing will apply. If you have an existing direct debit
        arrangement, Early Bird orders will be processed via direct debit on the
        <strong>20th May</strong>
        </p>
      </div>
      <check-box label="early bird pricing?"
                 field-name="wants_early_bird_pricing"
                 :disabled="isReadOnly">
      </check-box>
    </div>

    <div class="step-section">
      <div class="row">
        <div class="form-group col-md-6">
          <date-input label="Order Date"
                      field-name="order_date"
                      :disabled="isReadOnly">
          </date-input>
        </div>

        <div class="form-group col-md-6">
          <text-input label="Client consulter name"
                      field-name="client_consulter_name"
                      :disabled="isReadOnly">
          </text-input>
        </div>
      </div>

      <text-area label="Dry cow delivery instructions (goes on the order document sent to the client) "
                 field-name="delivery_instructions"
                 :disabled="isReadOnly">
      </text-area>

      <text-area label="Dry cow order notes, e.g. pricing"
                 field-name="order_notes"
                 :disabled="isReadOnly">
      </text-area>

      <h4 class="text-center">
        <check-box label="Order confirmed"
                   field-name="confirmed_order"
                   :disabled="isReadOnly">
        </check-box>
      </h4>

      <br>
      <hr>
      <br>

      <text-area label="Other Products Order to Retail"
                 subtext="Other notes and product orders for Retail, e.g. drench, trace elements. NOT TO BE USED FOR PRESCRIBING RVMs. This order will be sent to retail by email when the consult is submitted."
                 field-name="other_products_order"
                 :disabled="isReadOnly">
      </text-area>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

import NonHerdAnimalOrder from './teatseal_order/NonHerdAnimalOrder'
import DrugAllocation from './teatseal_order/DrugAllocation'
import { get_dairy_season_start_year } from '../../_helpers'
import { mapGetters } from 'vuex';
import { ModelSelect } from 'vue-search-select'
import Modal from '@/components/Modal'

export default {
  name: 'DryCowAndTeatsealOrder',
  mixins: [ baseComponent ],
  components: {
		ModelSelect,
    DrugAllocation,
    NonHerdAnimalOrder,
		Modal,
  },
	data() {
		return {
			showSelectHeiferAnimalForm: false,
			heifer: {}
		}
	},
  methods: {
		prepopulateHeifer: function () {
			this.heifer = {
				value: this.freeOtherAnimals[0].animal_ezyvet_id,
				text: this.freeOtherAnimals[0].animal_name,
			}
		},
    toggleNotifications: function() {
      this.setEmailNotification({
        slug: 'dc-other-products-order',
        value: Boolean(this.getFieldValue('other_products_order', this.$options.name))
      })
    },
    updateAllocations: function (fieldName, payload) {
      this.setFieldValue({
        fieldName: fieldName,
        stepName: 'DryCowAndTeatsealOrder',
        value: payload.allocations,
      })
    },
    previousHDCOfor(animal_ezyvet_id) {
      let hdcoId = Object.keys(this.nonHerdDcos).find((hdcoId) => 
        this.nonHerdDcos[hdcoId].animal_ezyvet_id == animal_ezyvet_id
      )
      return hdcoId ? Object.assign({hdcoId: hdcoId}, this.nonHerdDcos[hdcoId]) :  hdcoId
    },
    previousHDCOexistsfor(animal_ezyvet_id) {
      return Boolean(this.previousHDCOfor(animal_ezyvet_id))
    },
    addNewOtherAnimalForm: function(animalOption) {
      
      if (this.previousHDCOexistsfor(animalOption.value))
      {
        let nonHerdDcos = this.nonHerdDcos
        let previousHDCO = this.previousHDCOfor(animalOption.value)
        this.$set(nonHerdDcos[previousHDCO.hdcoId], 'delete', false)
        this.setFieldValue({
					fieldName: 'NON_HERD_DCO',
					stepName: 'DryCowAndTeatsealOrder',
					value: nonHerdDcos,
        })
        return
      }
      let newNonHerdDcos = this.newNonHerdDcos
      let index = Math.max(...Object.keys(newNonHerdDcos).concat([0])) + 1

      let newnonherddco = {
        frontend_id: index,
        animal_ezyvet_id: animalOption.value,
				animal_name: animalOption.text,
        client_animal: '',
        contact_name: '',
        contact_phone: '',
        date_required: null,
        allocations: [],
        disabled: false,
      }
      // newNonHerdDcos[index] = newnonherddco
      this.$set(newNonHerdDcos, index, newnonherddco)

      this.setFieldValue({
        fieldName: 'NEW_NON_HERD_DCO',
        // stepName: 'DryCowAndTeatsealOrder',
        value: newNonHerdDcos,
      })

			this.heifer = {}
    },
  },
  computed: {
		...mapGetters('currentConsult', ['hasFreeOtherAnimals', 'freeOtherAnimals']),
		canAddOtherAnimal: function ()
		{
			if (this.isReadOnly) { return false }
			else { 
				return this.hasFreeOtherAnimals
			}
		},
    nonHerdDcos: function ()
    {
      return this.getFieldValue('NON_HERD_DCO', 'DryCowAndTeatsealOrder')
    },
    newNonHerdDcos: function ()
    {
      return this.getFieldValue('NEW_NON_HERD_DCO', 'DryCowAndTeatsealOrder')
    },
		freeOtherAnimalsOptions: function ()
		{
			return this.freeOtherAnimals.map((animal) => { return { value: animal.animal_ezyvet_id, text: animal.animal_name }})
		},
    signedRequired: function () {
      let seasonStartYear = get_dairy_season_start_year() + 1
      let today = new Date()
      let maxDate = new Date(seasonStartYear+'-04-30')

      if (today <= maxDate) {
        return true
      }
      return false
    }
  },
};
</script>
